import React from 'react';
import { Activity } from 'lucide-react';

const StepCounter = ({ steps = 6540, goal = 10000 }) => {
  const progress = Math.min((steps / goal) * 100, 100);
  
  return (
    <div className="bg-white rounded-xl shadow-sm p-4">
      <div className="flex items-center gap-3 mb-2">
        <Activity size={24} className="text-primary" />
        <h3 className="text-lg font-medium">Today's Steps</h3>
      </div>
      
      <div className="flex items-end gap-2">
        <span className="text-3xl font-bold">{steps.toLocaleString()}</span>
        <span className="text-gray-500 mb-1">/ {goal.toLocaleString()}</span>
      </div>
      
      <div className="mt-3 h-2 w-full bg-gray-100 rounded-full">
        <div 
          className="h-full bg-primary rounded-full" 
          style={{ width: `${progress}%` }}
        />
      </div>
      
      <p className="text-sm mt-2 text-gray-500">
        {progress < 100 
          ? `${Math.round(goal - steps).toLocaleString()} steps to go!` 
          : 'Daily goal completed! 🎉'}
      </p>
    </div>
  );
};

export default StepCounter;